import { Fleet } from "../models/cars.model";
import * as _ from "lodash";

function getSelfDriveCars(): Array<Fleet> {
    const cars = [
        //Kudal HUB Cars
        {
            "Brand": "Maruti Suzuki",
            "Name": "Wagon R (CNG)",
            "Charges": [1399, 2099, 2799, 3499, 4199],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Devbag",
                "Devgad",
                "Kunkeshwar",
                "Kankavli",
                "Vaibhavwadi",
                "Sawantwadi",
                "Vengurla"
            ],
            "Hub": "Sawantwadi, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["100", "150", "200", "250", "300"],
            "ExtraKMCharges": [14, 12, 11, 10, 10],
            "Image": "wagonR_new.webp",
            "Images": ["wagonR_new.webp"],
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "23.56 to 34.05"
            },
            "isDiscountApplicable": true
        },
        {
            "Brand": "Toyota",
            "Name": "Glanza",
            "Charges": [2000],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Kankavli"
            ],
            "Hub": "Kudal, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [14],
            "Image": "glanza.webp",
            "Images": ["glanza.webp"],
            "Details": {
                "Fuel": "Petrol ",
                "SeatingCapacity": 5,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "22.3"
            }
        },
        {
            "Brand": "Hyundai",
            "Name": "Aura (CNG)",
            "Charges": [1799, 2499, 3199, 3899, 4599],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Devbag",
                "Devgad",
                "Kunkeshwar",
                "Kankavli",
                "Vaibhavwadi",
                "Sawantwadi",
                "Vengurla"
            ],
            "Hub": "Kudal, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["100", "150", "200", "250", "300"],
            "ExtraKMCharges": [16, 14, 13, 12, 12],
            "Image": "aura.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "22.41 to 31.12"
            },
            "isDiscountApplicable": true
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Ciaz",
            "Charges": [2379, 3079, 3779, 4479, 5179],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Devbag",
                "Devgad",
                "Kunkeshwar",
                "Kankavli",
                "Vaibhavwadi",
                "Sawantwadi",
                "Vengurla"
            ],
            "Hub": "Sawantwadi, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["100", "150", "200", "250", "300"],
            "ExtraKMCharges": [15, 13, 12, 11, 11],
            "Image": "ciaz.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 5,
                "LuggageCapacity": 5,
                "Transmission": "Manual",
                "Avg/Ltr": "28"
            },
            "isDiscountApplicable": true
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Ertiga (CNG)",
            "Charges": [2799, 3499, 4199, 4899, 5599],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Devbag",
                "Devgad",
                "Kunkeshwar",
                "Kankavli",
                "Vaibhavwadi",
                "Sawantwadi",
                "Vengurla"
            ],
            "Hub": "Sawantwadi, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["100", "150", "200", "250", "300"],
            "ExtraKMCharges": [16, 14, 13, 12, 12],
            "Image": "ertiga_new.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 7,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "20.3 to 26.11"
            },
            "isDiscountApplicable": true
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "XL6 (CNG)",
            "Charges": [2939, 3639, 4339, 5039, 5739],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Devbag",
                "Devgad",
                "Kunkeshwar",
                "Kankavli",
                "Vaibhavwadi",
                "Sawantwadi",
                "Vengurla"
            ],
            "Hub": "Kudal, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["100", "150", "200", "250", "300"],
            "ExtraKMCharges": [18, 16, 15, 14, 14],
            "Image": "xl6.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 6,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "20.3 to 26.11"
            },
            "isDiscountApplicable": true
        },
        // {
        //     "Brand": "Toyota",
        //     "Name": "Innova",
        //     "Charges": [4000],
        //     "HalfDayCharges": [],
        //     "UOM": "Day",
        //     "StartTime": "12 AM",
        //     "EndTime": "12 AM",
        //     "Locations": [
        //         "Kudal",
        //         "Malvan",
        //         "Tarkarli",
        //         "Devbag",
        //         "Devgad",
        //         "Kunkeshwar",
        //         "Kankavli",
        //         "Vaibhavwadi",
        //         "Sawantwadi",
        //         "Vengurla"
        //     ],
        //     "Hub": "Sawantwadi, Maharashtra",
        //     "isSelfDrive": true,
        //     "SecurityDeposit": 5000,
        //     "KMIncluded": ["120"],
        //     "ExtraKMCharges": [18],
        //     "Image": "innova.webp",
        //     "Details": {
        //         "Fuel": "Diesel",
        //         "SeatingCapacity": 7,
        //         "LuggageCapacity": 4,
        //         "Transmission": "Manual",
        //         "Avg/Ltr": "12"
        //     }
        // },
        {
            "Brand": "Mahindra",
            "Name": "Thar Roxx",
            "Charges": [4000],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Kudal",
                "Malvan",
                "Tarkarli",
                "Devbag",
                "Devgad",
                "Kunkeshwar",
                "Kankavli",
                "Vaibhavwadi",
                "Sawantwadi",
                "Vengurla"
            ],
            "Hub": "Sawantwadi, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 7500,
            "KMIncluded": ["120"],
            "ExtraKMCharges": [18],
            "Image": "thar_roxx.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 5,
                "LuggageCapacity": 6,
                "Transmission": "Manual",
                "Avg/Ltr": "12.4 to 15.2"
            },
            "isDiscountApplicable": false
        },



        //Navi Mumbai HUB Cars
        {
            "Brand": "Maruti Suzuki",
            "Name": "Wagon R (CNG)",
            "Charges": [2200],
            "HalfDayCharges": [2200],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Thane",
                "Mumbai"
            ],
            "Hub": "Airoli, Navi Mumbai",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [14],
            "Image": "wagonR_new.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "23.56 to 34.05"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Celerio (CNG)",
            "Charges": [2200],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Thane",
                "Mumbai"
            ],
            "Hub": "Airoli, Navi Mumbai",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [0],
            "Image": "celerio.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "20 to 28.50"
            }
        },
        {
            "Brand": "Hyundai",
            "Name": "Aura (CNG)",
            "Charges": [2500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Thane",
                "Mumbai"
            ],
            "Hub": "Airoli, Navi Mumbai",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [16],
            "Image": "aura.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "22.41 to 31.12"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Ertiga (CNG)",
            "Charges": [3500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Thane",
                "Mumbai"
            ],
            "Hub": "Airoli, Navi Mumbai",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [18],
            "Image": "ertiga_new.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 7,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "20.3 to 26.11"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "XL6 (CNG)",
            "Charges": [3500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Thane",
                "Mumbai"
            ],
            "Hub": "Mulund, Mumbai",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [18],
            "Image": "xl6.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 6,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "20.3 to 26.11"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "XL6 (CNG)",
            "Charges": [3500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Thane",
                "Mumbai"
            ],
            "Hub": "Boriwali, Mumbai",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [18],
            "Image": "xl6.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 6,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "20.3 to 26.11"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Dzire (CNG)",
            "Charges": [2500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Navi Mumbai",
                "Thane",
                "Mumbai"
            ],
            "Hub": "Airoli, Navi Mumbai",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["300"],
            "ExtraKMCharges": [16],
            "Image": "dzire.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "22.41 to 31.12"
            }
        },
        //Ratnagiri HUB Cars
        {
            "Brand": "Hyundai",
            "Name": "XCent (CNG)",
            "Charges": [2000],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [16],
            "Image": "xcent.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "17.36 to 25.4"
            }
        },
        {
            "Brand": "Hyundai",
            "Name": "XCent (CNG)",
            "Charges": [2500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["250"],
            "ExtraKMCharges": [16],
            "Image": "xcent.webp",
            "Details": {
                "Fuel": "Petrol + CNG",
                "SeatingCapacity": 5,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "17.36 to 25.4"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Dzire",
            "Charges": [2000],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [16],
            "Image": "dzire.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 5,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "28.4"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Dzire",
            "Charges": [2500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["250"],
            "ExtraKMCharges": [16],
            "Image": "dzire.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 5,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "28.4"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Ertiga",
            "Charges": [2299],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["100"],
            "ExtraKMCharges": [16],
            "Image": "ertiga_new.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 7,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "25.47"
            }
        },
        {
            "Brand": "Maruti Suzuki",
            "Name": "Ertiga",
            "Charges": [2899],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["250"],
            "ExtraKMCharges": [16],
            "Image": "ertiga_new.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 7,
                "LuggageCapacity": 3,
                "Transmission": "Manual",
                "Avg/Ltr": "25.47"
            }
        },
        {
            "Brand": "Toyota",
            "Name": "Innova",
            "Charges": [3500],
            "HalfDayCharges": [],
            "UOM": "Day",
            "StartTime": "12 AM",
            "EndTime": "12 AM",
            "Locations": [
                "Ratnagiri",
                "Ganpatipule"
            ],
            "Hub": "Ratnagiri, Maharashtra",
            "isSelfDrive": true,
            "SecurityDeposit": 5000,
            "KMIncluded": ["120"],
            "ExtraKMCharges": [18],
            "Image": "innova.webp",
            "Details": {
                "Fuel": "Diesel",
                "SeatingCapacity": 7,
                "LuggageCapacity": 4,
                "Transmission": "Manual",
                "Avg/Ltr": "12"
            }
        }
    ];
    const updatedCars = cars.map(car => ({
        ...car,
        SecurityDeposit: car.Name === "Thar Roxx" ? 7500 : 5000
    }));
    return _.sortBy(updatedCars, ['Charges']);
}
export default getSelfDriveCars;